import type { SVGProps } from "react";
const SuiWarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#warning_svg__a)">
      <path
        fill="currentColor"
        d="M10.603.061c8.692-.837 15.37 7.07 12.864 15.498-2.772 9.323-15.222 11.462-21.079 3.694C-3.134 11.93 1.465.942 10.603.061m2.858 15.103.734-9.092c.287-3.574-4.695-3.575-4.408 0l.734 9.092h2.941m-1.92 1.916c-1.858.384-1.743 3.333.079 3.55 3.047.364 2.714-4.13-.079-3.55"
      />
      <path
        fill="#fff"
        d="M13.46 15.163h-2.94l-.735-9.091c-.285-3.576 4.695-3.575 4.409 0zM11.54 17.079c2.794-.58 3.127 3.915.08 3.551-1.822-.217-1.938-3.166-.08-3.551"
      />
    </g>
    <defs>
      <clipPath id="warning_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SuiWarningIcon;
